import { Injectable } from "@angular/core";
import { FirestoreV9Service } from "../../services";
import { addDoc, collection, FirestoreDataConverter } from "firebase/firestore";
import { WorkOrderItem } from "@dis/models";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class WorkOrderCollection extends FirestoreV9Service<WorkOrderItem> {
  protected override basePath = "work-orders";
  protected override baseConverter: FirestoreDataConverter<WorkOrderItem> = {
    fromFirestore(snapshot, options): WorkOrderItem {
      const data = snapshot.data(options);
      return data as WorkOrderItem;
    },

    toFirestore(item: WorkOrderItem): any {
      const data: any = { ...item };
      return data;
    },
  };

  getWorkOrderWithUid$(uid: string): Observable<WorkOrderItem> {
    return this.doc$(uid);
  }

  async updateCustomWorkOrder(uid: string, value: WorkOrderItem) {
    this.upsert(uid, value);
  }

  async createWorkOrder(value: WorkOrderItem) {
    const collRef = collection(this.firestore, this.basePath).withConverter(this.baseConverter);
    const docRef = await addDoc(collRef, value);
    value.uid = docRef.id;
    this.upsert(value.uid, value);
  }
}
